import React, { useState } from "react";
import FormWH from "../forms/FormWH";
import useHttp from "../hooks/use-http";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import WHUserInputModal from "../modals/WHUserInputModal";
import { useTranslation } from "react-i18next";
import "./NieuweCheckWH.css";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NieuweCheckWH = () => {
  const navigate = useNavigate();
  const { user } = useAuth0();
  const { i18n } = useTranslation();
  const [showUserInputModal, setShowUserInputModal] = useState(false);
  const [preprocessResponse, setPreprocessResponse] = useState();

  console.log(i18n.language);

  const [runConfig, setRunConfig] = useState({
    name: user?.name || "",
    language: i18n.language,
    email: user?.email || "",
  });


  const {
    sendRequest: startRunRequest,
    isLoading: startRunLoading,
    error: startRunError,
  } = useHttp();

  function startRun() {
    const formData = new FormData();
    formData.append("contract_file", runConfig.contract_file);

    if (runConfig?.gtc_file) {
      formData.append("gtc_file", runConfig.gtc_file);
    }

    console.log(runConfig)

    formData.append("run_config", JSON.stringify(runConfig));

    function applyData(res) {
      if (res.userInputRequired) {
        setPreprocessResponse(res);
        setRunConfig({
          ...runConfig,
          request_id: res.requestId,
        });
        setShowUserInputModal(true);
      } else {
        navigate("/");
      }
    }

    startRunRequest(
      {
        url: `${REACT_APP_BACKEND_URL}/run/start_house_rent`,
        method: "POST",
        body: formData,
        isFileUpload: true,
      },
      applyData
    );
  }

  return (
    <div className="nc-container">
      <FormWH
        startRun={startRun}
        runLoading={startRunLoading}
        runError={startRunError}
        runConfig={runConfig}
        setRunConfig={setRunConfig}
      />
      <WHUserInputModal
        visible={showUserInputModal}
        setVisible={setShowUserInputModal}
        startRun={startRun}
        preprocessResponse={preprocessResponse}
        runConfig={runConfig}
        setRunConfig={setRunConfig}
      />
    </div>
  );
};

export default NieuweCheckWH;
